module.exports = __webpack_public_path__ + "ndashboard_icon.svg";